import React from 'react';
import PropTypes from 'prop-types';
import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Badge, Icon } from '@openedx/paragon';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  RiBookOpenLine, RiBroadcastLine, RiFeedbackLine, RiFileList2Line,
  RiStackLine, RiSurveyLine, RiTextSnippet, RiUserVoiceLine, RiVideoLine,
} from '@remixicon/react';

import messages from '../messages';

const TYPE_ICON = {
  course: RiBookOpenLine,
  video: RiVideoLine,
  assessment: RiSurveyLine,
  text: RiTextSnippet,
  material: RiFileList2Line,
  live_session: RiBroadcastLine,
  feedback: RiFeedbackLine,
  role_play: RiUserVoiceLine,
};

const resolveImage = (path) => {
  if (!path) { return null; }
  return path.startsWith('http') ? path : `${getConfig().LMS_BASE_URL}${path}`;
};

const PathwayComponentsList = ({ components }) => {
  const intl = useIntl();
  if (!components || components.length === 0) { return null; }

  return (
    <section className="discover-pathway__components">
      <h2 className="discover-pathway__components-title">
        {intl.formatMessage(messages.curriculumTitle)}
      </h2>
      <ul className="discover-pathway__components-list">
        {components.map((component, index) => {
          const imageUrl = resolveImage(component.imageUrl);
          return (
            <li key={component.id} className="discover-pathway__components-item">
              <span className="discover-pathway__components-index">{index + 1}</span>
              {imageUrl ? (
                <span
                  className="discover-pathway__components-tile discover-pathway__components-tile--image"
                  style={{ backgroundImage: `url(${imageUrl})` }}
                  role="img"
                  aria-label={component.displayName}
                />
              ) : (
                <span className="discover-pathway__components-tile">
                  <Icon src={TYPE_ICON[component.componentType] || RiStackLine} />
                </span>
              )}
              <div className="discover-pathway__components-meta">
                <span className="discover-pathway__components-name">
                  {component.displayName || component.contentId}
                </span>
                {!component.isMandatory && (
                  <Badge variant="soft-primary" className="discover-pathway__components-optional">
                    {intl.formatMessage(messages.optional)}
                  </Badge>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

PathwayComponentsList.propTypes = {
  components: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    contentId: PropTypes.string,
    componentType: PropTypes.string,
    displayName: PropTypes.string,
    imageUrl: PropTypes.string,
    isMandatory: PropTypes.bool,
  })),
};

PathwayComponentsList.defaultProps = {
  components: [],
};

export default PathwayComponentsList;
